export class eGENA_CRMs {
	public Sofortmaßnahmen : string;
	public Therapie : string;
	public Diagnose : string;

	public constructor(Sofortmaßnahmen : string, Therapie : string, Diagnose : string) {
		this.Sofortmaßnahmen = Sofortmaßnahmen;
		this.Therapie = Therapie;
		this.Diagnose = Diagnose;
	}


	public static fromJSONobject(object : any) : eGENA_CRMs {
		if (!('Sofortmaßnahmen' in object))
			throw new Error("Das JSON-Objekt ist nicht im erwarteten Format: Das Attribut 'Sofortmaßnahmen' ist nicht definiert. JSON-Objekt: " + JSON.stringify(object, null, 4));

		if (!('Therapie' in object))
			throw new Error("Das JSON-Objekt ist nicht im erwarteten Format: Das Attribut 'Therapie' ist nicht definiert. JSON-Objekt: " + JSON.stringify(object, null, 4));

		if (!('Diagnose' in object))
			throw new Error("Das JSON-Objekt ist nicht im erwarteten Format: Das Attribut 'Diagnose' ist nicht definiert. JSON-Objekt: " + JSON.stringify(object, null, 4));
			
		return new eGENA_CRMs(object.Sofortmaßnahmen,object.Therapie, object.Diagnose);
	}
}


// WEBPACK FOOTER //
// ./src/visionet/CRMs.ts